import useAccountControlActions from 'dataflow/billingPortal/actions/useAccountControl.actions';
import { convertArrayToDropdownArrayFormat, isArrayNotEmpty, isStringTrimNotEmpty } from 'functions';
import { useCustomSelector } from 'hooks';
import React, { useEffect, useRef, useState } from 'react';

export default function useDropdownLists() {

    const { userPermissions } = useCustomSelector("userManagementReducers");
    const [isFiltering, setIsFiltering] = useState();
    const [isTrial, setIsTrial] = useState("all");
    const [isSuspended, setIsSuspended] = useState("all");

    const selectedComId = useRef();
    const selectedCompanyName = useRef();

    let { 
        allComList,
        getComList_requesting
	} = useCustomSelector("accountControl");

    useEffect(() => {
        if (!getComList_requesting) setIsFiltering(false);
    },[getComList_requesting])

    // Get list of company IDs
    const { getAllComList } = useAccountControlActions();

    let comIdList = [], companyNameList = [];
    if (isArrayNotEmpty(allComList)) {
        allComList.map((comDetails) => {
            let comId = comDetails?.ComId;
            let companyName = comDetails?.ComName;

            comIdList.push({
                label: comId + " - " + companyName,
                value: comId,
            });
            companyNameList.push(companyName);
        })
    }

    useEffect(() => {
        if (userPermissions?.Internal_AccControl_View) getAllComList();
    }, []);

    function onFilterSubmit(setFilterOptions, filterOptions = {}, isReset) {
        if (isReset) {
            setFilterOptions(filterOptions);
            selectedComId.current = "";
            selectedCompanyName.current = "";
            setIsTrial(true);
            setIsSuspended(false);
        }
        else {
            setIsFiltering(true);
            setFilterOptions({
                ...filterOptions,
                comId: selectedComId.current,
                comName: selectedCompanyName.current,
                isSuspended, isTrial
            })
        }
    }

    return {
        comIdList,
        companyNameList: convertArrayToDropdownArrayFormat(companyNameList.sort()),
        selectedComId, 
        selectedCompanyName,
        isTrial, setIsTrial,
        isSuspended, setIsSuspended,
        isFiltering, onFilterSubmit,
    }
}